import { PlayIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import type { TranslationKey } from '@/i18n/types'

import { VideoPlayerDialog } from './video-player-dialog'

type Props = {
  titleKey: TranslationKey
  youtubeId: string
}

export const PlayVideoButton = ({ titleKey, youtubeId }: Props) => {
  const { t } = useTranslation()

  return (
    <VideoPlayerDialog
      title={t(titleKey)}
      trigger={
        <Button className="text-text-secondary" variant="secondary">
          <PlayIcon />
          {t('videos.watchGuideButton')}
        </Button>
      }
      youtubeId={youtubeId}
    />
  )
}

export default PlayVideoButton
